import LogoSvg from "../../assets/svgs/logo.svg";
import styles from "./Header.module.css";
import UserMenu from "./UserMenu";
import { BurgerMenu } from "./BurgerMenu";

export default function Header() {
  return (
    <div className={styles.header}>
      <img src={LogoSvg} alt="" className={styles.logo} />
      {/* Desktop: user info */}
      <div className={styles.desktopMenu}>
        <UserMenu />
      </div>
      {/* Mobile: burger */}
      <div className={styles.mobileMenu}>
        <BurgerMenu />
      </div>
    </div>
  );
}
